import { defineStore } from 'pinia'

/**
 * Converted from store/entityIdSerialNumber.js. Supplies the serial numbers the
 * mock API uses to mint entity ids, which is why it is persisted: it must not
 * hand out an id an earlier session already used.
 */
export const useEntityIdSerialNumberStore = defineStore(
  'entityIdSerialNumber',
  {
    state: () => ({
      serialNumber: 9000,
    }),
    getters: {
      getSerialNumber: (state) => state.serialNumber,
    },
    actions: {
      increment(): void {
        // eslint-disable-next-line no-console
        console.debug(
          `store: mutating lastSerialNumber from ${this.serialNumber} to ${
            this.serialNumber + 1
          }`
        )
        this.serialNumber++
      },
    },
  }
)
